export class Config {
  public static defaultRoute = 'vouchers';
}
